export default __webpack_public_path__ + "static/media/DR_RABINCHANDRA.784ac9d0.JPG";